<h2 *ngIf="!modalData?.perDiem?.timeSheetPerDiemId && !modalData.timeSheetStatusError" mat-dialog-title>
	Add Per Diem
</h2>
<h2 *ngIf="modalData?.perDiem?.timeSheetPerDiemId && !modalData.timeSheetStatusError" mat-dialog-title>
	Edit Per Diem
</h2>
<h2 *ngIf="modalData.timeSheetStatusError" mat-dialog-title>Per Diem</h2>

<mat-error *ngIf="startWithinTrip || endWithinTrip">{{ withinTripWarningMessage }}</mat-error>
<mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>

<div *ngIf="modalData.timeSheetStatusError && !modalData?.timeSheetLockOutError">
	<mat-error>{{ modalData.timeSheetStatusError }}</mat-error>
</div>

<div *ngIf="modalData.timeSheetLockOutError">
	<mat-error>{{ modalData.timeSheetLockOutError }}</mat-error>
</div>

<br />
<mat-dialog-content [formGroup]="form">
	<div layout-gt-xs="row" class="d-flex">
		<mat-form-field class="mr-3" fxFlex="50%">
			<input
				matInput
				[matDatepicker]="perDiemStartCalendar"
				[min]="minDateValue"
				[max]="maxDateValue"
				formControlName="perDiemStart"
				placeholder="Per Diem Start (UTC)"
				(dateChange)="isDateWithinTrip($event.target.value)"
			/>
			<mat-datepicker-toggle matSuffix [for]="perDiemStartCalendar"> </mat-datepicker-toggle>
			<mat-datepicker [touchUi]="modalData.isMobile" #perDiemStartCalendar></mat-datepicker>
		</mat-form-field>
		<mat-error *ngIf="isSubmitted && form.get('perDiemStart').hasError('required')">
			Per-diem start date is required
		</mat-error>
		<div class="time-picker">
			<ngx-timepicker-field
				(change)="onTimeChange($event, 'startTime')"
				[format]="24"
				formControlName="startTime"
				[defaultTime]="form.get('startTime').value"
			></ngx-timepicker-field>
			<mat-error
				*ngIf="
					isSubmitted &&
					(form.get('startTime').hasError('required') || startTimeHoursError || startTimeMinutesError)
				"
			>
				Per-diem start time is required
			</mat-error>
		</div>
	</div>

	<div layout-gt-xs="row" class="d-flex">
		<mat-form-field class="mr-3" fxFlex="50%">
			<input
				matInput
				[matDatepicker]="perDiemEndCalendar"
				[min]="minDateValue"
				[max]="maxDateValue"
				formControlName="perDiemEnd"
				placeholder="Per Diem End (UTC)"
			/>
			<mat-datepicker-toggle matSuffix [for]="perDiemEndCalendar"> </mat-datepicker-toggle>
			<mat-datepicker
				[startAt]="maxDateValue"
				[touchUi]="modalData.isMobile"
				#perDiemEndCalendar
			></mat-datepicker>
		</mat-form-field>
		<mat-error *ngIf="isSubmitted && form.get('perDiemEnd').hasError('required')">
			Per-diem end date is required
		</mat-error>
		<div class="time-picker">
			<ngx-timepicker-field
				(change)="onTimeChange($event, 'endTime')"
				[format]="24"
				formControlName="endTime"
				[defaultTime]="form.get('endTime').value"
			></ngx-timepicker-field>
			<mat-error
				*ngIf="
					isSubmitted &&
					(form.get('endTime').hasError('required') || endTimeHoursError || endTimeMinutesError)
				"
			>
				Per-diem end time is required
			</mat-error>
		</div>
	</div>

	<br />
	<div layout-gt-xs="row">
		<mat-form-field class="input-full-width">
			<textarea
				matInput
				cdkTextareaAutosize
				placeholder="Comments"
				formControlName="comments"
				[required]="startWithinTrip || endWithinTrip"
			></textarea>
		</mat-form-field>
		<mat-error *ngIf="form.get('comments').hasError('required')">
			Comments are required when per diem is in the middle of a trip
		</mat-error>
	</div>

	<div
		*ngIf="
			(modalData?.timeSheetStatusError && !modalData?.timeSheetLockOutError) || modalData?.timeSheetLockOutError
		"
	>
		<mat-dialog-actions fxLayoutAlign="end end">
			<button class="mat-raised-button" (click)="close()">Close</button>
		</mat-dialog-actions>
	</div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!modalData.timeSheetStatusError && !modalData.timeSheetLockOutError" fxLayoutAlign="end end">
	<button class="mat-raised-button" (click)="close()">
		Close
	</button>

	<button
		*ngIf="modalData && modalData?.perDiem?.timeSheetPerDiemId"
		color="warn"
		mat-button
		class="mat-raised-button"
		(click)="deletePerDiem()"
	>
		Delete
	</button>

	<button class="mat-raised-button mat-primary" (click)="save()">
		Save
	</button>
</mat-dialog-actions>
